import { useQuery } from 'react-query'
import toastr from 'react-hot-toast'
import { fetchWrapper } from 'utils/fetchWrapper'
import { CACHE_AND_STALE_TIME } from 'constants/index'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type { SingleAccountResponse } from 'types/Account'

const getAccountByID = (accountID: string | null | undefined) => {
  const url = generateURL(SPARK_RESOURCE_TYPES.ACCOUNTS, [], accountID)
  return fetchWrapper<SingleAccountResponse>({
    url: url,
    method: 'GET',
  })
}

export function useAccountByID(accountID: string | null | undefined) {
  const { data, ...rest } = useQuery(
    ['Account', accountID],
    () => getAccountByID(accountID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to fetch Account: ${error.message}`)
        }
      },
      enabled: Boolean(accountID),
      ...CACHE_AND_STALE_TIME,
    }
  )

  const { data: responseData, ...restData } = data || {}

  return {
    account: responseData,
    ...restData,
    ...rest,
  }
}
